/* import __COLOCATED_TEMPLATE__ from './mass-start-timing-record-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { use } from 'ember-resources';
import { socketRecordTable } from 'bullitttime-embercomponents/utils/socket-record-table-resource';

export default class MassStartTimingRecordTableComponent extends Component
{
	@service ajax;
	@service socketGuru;

	// Primary table: unassociated start timing records. Class-group associations
	// are layered on top — seeded via afterStart and kept live by the
	// massStartClassGroupAssociation listener below (keyed by StartTimingRecordId,
	// so they ride a separate listener rather than the table's id-keyed stream).
	@use massStartRecords = socketRecordTable(() =>
	{
		const { event } = this.args;
		return {
			socketGuru: this.socketGuru,
			ajax: this.ajax,
			channels: 'startAssociationRecord',
			endpoint: () => event ? `/events/${event.id}/startAssociationRecords` : null,
			transform: (record) => this.transformRecord(record),
			sort: this.sortFn,
			afterStart: (table) => this.loadClassGroupAssociations(table),
		};
	});

	constructor()
	{
		super(...arguments);
		this._boundClassGroupAssociation = this._handleClassGroupAssociation.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundClassGroupAssociation);
	}

	willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundClassGroupAssociation);
		super.willDestroy();
	}

	transformRecord(record)
	{
		//only show unassociated start timing records
		if(record.entryBib == null && record.startImpulseId != null)
		{
			record.classGroupAssociations = [];
			return record;
		}
		return null;
	}

	sortFn(a,b)
	{
		var aTime = a.startImpulseTime || a.assignedStartTime;
		var bTime = b.startImpulseTime || b.assignedStartTime;
		if(aTime == undefined)
			aTime = null;
		if(bTime == undefined)
			bTime = null;

		//sort on id to keep a consistent order for wave start groups
		//records are guarenteed not to have the same id
		if(aTime == bTime)
		{
			return a.id>b.id ? -1 : 1;
		}

		return aTime>bTime ? -1 : aTime<bTime ? 1 : 0 ;
	}

	async loadClassGroupAssociations(table)
	{
		if(!this.args.event)
		{
			return;
		}
		var associations = await this.ajax.request("/events/"+this.args.event.id+"/massStartClassGroupAssociations");
		associations.forEach((record) => this.applyClassGroupAssociation(table, record));
	}

	applyClassGroupAssociation(table, record)
	{
		var startTimingRecordId = record.StartTimingRecordId;
		var associationName = record.classGroupName || record.seedGroup;

		table.updateWhere(
			(rec) => rec.id == startTimingRecordId,
			(rec) => ({
				...rec,
				classGroupAssociations: [...rec.classGroupAssociations, associationName]
			})
		);
	}

	_handleClassGroupAssociation(event)
	{
		const { eventName, data } = event.detail;
		if(eventName != "massStartClassGroupAssociation")
		{
			return;
		}
		var parsed = JSON.parse(data);
		if(parsed.type == 'INSERT')
		{
			this.applyClassGroupAssociation(this.massStartRecords, JSON.parse(parsed.row));
		}
		// UPDATE and DELETE were no-ops in the original implementation.
	}

	@action
	startImpulseClicked(timingRecord)
	{
		this.args.startImpulseSelectAction(timingRecord);
	}
}
